import http from "../http-common";

class FacultyService {
  createFaculty(data) {
    return http.post(`/api/faculty`, data);
  }
  getFacultys() {
    return http.get(`/api/faculty`);
  }
  updateFaculty(id, data) {
    return http.put(`/api/faculty/${id}`, data);
  }
}

export default new FacultyService();